module.exports = __webpack_public_path__ + "asset/image/fan-off-3a42.svg";